import { render, staticRenderFns } from "./landingRobotics-var1.vue?vue&type=template&id=3d51dc43&scoped=true&"
import script from "./landingRobotics-var1.vue?vue&type=script&lang=js&"
export * from "./landingRobotics-var1.vue?vue&type=script&lang=js&"
import style0 from "./landingRobotics-var1.vue?vue&type=style&index=0&id=3d51dc43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d51dc43",
  null
  
)

export default component.exports